import * as $ from 'jquery';
import { ui } from './ui';
import { Sendform } from '../libs/sendform/sendform2';

$( document ).ready(function() {
    let projectApp = new App();
    projectApp.init();
});

class App {
    constructor(){}

    init() {
        const $body = $('body')

        ui.initLazyLoadImg()

        if ($('.js_modal-location').hasClass('__open')) {
            ui.openPopup('#modal-location')
        }

        if($(window).width() <= 780) {
            ui.initSlider('.js_slider-blog')
        }

        if($(window).width() <= 900) {
            ui.addScrollClass('.js_scroll-top')
        }

        ui.initDefaultSelect('.js_select')

        // Popup init
        ui.popupForm('.js_btn-popup')
        ui.closePopup('.js_popup-close')

        ui.initScrollStyle('.js_ui-scroll')

        //Send form
        new Sendform('.js_form-location', {
            msgValEachField: true,
            msgError: 'Sorry, cannot send this form',
            modalOpen: false,
            success: data => {
                let url = JSON.parse(data.response).redirect_to
                window.location.href = url
            }
        })

        // Mobile menu
        $body.on('click', '.js_menu-btn', function(e) {
            e.preventDefault()
            const $cnt = $('.js_menu-cnt')
            $(this).toggleClass('__active')
            if($(this).hasClass('__active')){
                $cnt.addClass('__show-menu')
                $('body').addClass('__overlay')
            } else{
                $cnt.removeClass('__show-menu')
                $('body').removeClass('__overlay')
            }
        })

        // Search
        $body.on('click', '.js_search-btn', function(e) {
            e.preventDefault()
            $(this).closest('.header-wrap-search').addClass('__open')
            $('.js_search-blk').addClass('__active')
        })
        $body.on('click', '.js_close-search', function(e) {
            e.preventDefault()
            $(this).closest('.header-wrap-search').removeClass('__open')
            $(this).closest('.js_search-blk').removeClass('__active')
        })

        $body.on('submit', '.js_search-submit', function(e) {
            const $inp = $(this).find('.js_search-inp')
            const $msg = $(this).find('.js_search-error')
            if ($inp.val().length === 1) {
                $inp.addClass('error')
                $msg.removeClass('__hidden')
                return false
            } else {
                $inp.removeClass('error')
                $msg.addClass('__hidden')
            }
            $('.js_search-value').val($inp.val())
            const $currPage = $('.js_get-url')
            if ($currPage.length) {
                e.preventDefault()
                $currPage.trigger('click')
            }
        })
    }
};
